const trustBadges = [
  {
    name: 'National Aging In Place Council',
    logo: '/logos/trust/naipc-official.png',
    alt: 'National Aging In Place Council Member',
  },
  {
    name: 'Netty Awards',
    logo: '/logos/trust/netty-award-official.svg',
    alt: 'Netty Award Winner - Best ElderTech',
  },
  {
    name: 'FamTech.org',
    logo: '/logos/trust/famtech-official.png',
    alt: 'FamTech.org Startup Showcase - VC Select',
  },
  {
    name: 'PeachScore Accelerator',
    logo: '/logos/trust/peachscore-official.png',
    alt: 'PeachScore Accelerator',
    iconOnly: true,
  },
  {
    name: 'USC Leonard Davis School of Gerontology',
    logo: '/logos/trust/usc-gerontology-official.png',
    alt: 'USC Leonard Davis School of Gerontology',
  },
];

const TrustBadgesSection = () => {
  return (
    <section className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <p className="text-center text-sm font-bold uppercase tracking-widest text-muted-foreground mb-8">
          Recognized By
        </p>
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
          {trustBadges.map((badge) => (
            <div
              key={badge.name}
              className="flex items-center justify-center gap-2 opacity-80 hover:opacity-100 transition-opacity duration-300"
            >
              <img
                src={badge.logo}
                alt={badge.alt}
                className={
                  'iconOnly' in badge && badge.iconOnly
                    ? 'h-10 md:h-12 w-auto object-contain'
                    : 'h-12 md:h-14 w-auto max-w-[200px] object-contain'
                }
                loading="lazy"
              />
              {'iconOnly' in badge && badge.iconOnly && (
                <span className="text-sm font-bold text-foreground/70 leading-tight">
                  PeachScore<br />Accelerator
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadgesSection;
